import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { Validators } from '@angular/forms';
import { SocProfessionListService } from '@brightside-web/desktop/data-access/shared';
import { ConfigEligType } from './product-eligibility/product-eligibility.component';

@Pipe({
    name: 'genCellValue',
    standalone: false
})
export class GenCellValuePipe implements PipeTransform {
  constructor(private readonly _socProfessionListService: SocProfessionListService) {}

  transform(value: ConfigEligType[]): string {
    const items: string[] = [];
    let missingRequired = false;
    let isSSN = false;
    let lastFour = '****';

    value.forEach( item => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (item.control.hasValidator(Validators.required) && !item.value) {
       missingRequired = true;
       return;
      }
      if (item.key === 'fullSSN' || item.key === 'lastFourSSN') {
        isSSN = true;
        if (item.value) {
          const splitSSN = item.value.split('-');
          if (splitSSN.length > 0) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            lastFour = splitSSN.pop();
          }
            return;
        }
      }
      if (item.key === 'profession') {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (item.control.hasValidator(Validators.required) && !item.value) {
          missingRequired = true;
          return;
        }
        const display =
          item.summaryDisplayValue ||
          this._socProfessionListService.getDisplayTitleFromValue(item.value) ||
          item.value;
        if (display && display !== 'middle') {
          items.push(display);
        }
        return;
      }
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      const itemToWorkOn = item.value;
      if (itemToWorkOn && itemToWorkOn !== 'middle') {
        items.push(itemToWorkOn);
      }

    });

    if (value[0].type.toLowerCase() === 'date' && value[0].value ) {
      const datePipe: DatePipe = new DatePipe('en-US');
      return datePipe.transform(value[0].value, 'longDate') as string;

    }

    if (value[0].key === 'annualSalary') {
     const currencyPipe: CurrencyPipe = new CurrencyPipe('en-US');
     return currencyPipe.transform(value[0].value ?? 0) as string;
    }

    return missingRequired ? '-' : isSSN ? `***-**-${lastFour}` : items.join(' ');
  }

}
